import { useState } from 'react';
import { Link } from 'react-router-dom';
import { UtensilsCrossed } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Input } from '../ui/input';

export const RecipePickerDialog = ({ open, onOpenChange, recipes, onSelect }) => {
  const [searchQuery, setSearchQuery] = useState('');

  const filtered = recipes.filter(
    (r) =>
      r.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      r.country.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[80vh] overflow-hidden flex flex-col">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl">Choisir une recette</DialogTitle>
        </DialogHeader>

        <div className="mb-4">
          <Input
            type="text"
            placeholder="Rechercher une recette..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full"
            data-testid="recipe-search-input"
          />
        </div>

        <div className="overflow-y-auto flex-1 space-y-2 pr-2">
          {filtered.length === 0 ? (
            <div className="text-center py-8 text-worldplate-muted">
              <UtensilsCrossed className="w-12 h-12 mx-auto mb-3 opacity-50" />
              <p>Aucune recette trouvée</p>
              <Link to="/recipes/new" className="text-worldplate-primary hover:underline text-sm">
                Ajouter une recette
              </Link>
            </div>
          ) : (
            filtered.map((recipe) => (
              <button
                key={recipe.id}
                onClick={() => onSelect(recipe.id)}
                className="w-full p-3 text-left bg-worldplate-subtle hover:bg-worldplate-primary/10 rounded-lg transition-colors flex items-center gap-3"
                data-testid={`select-recipe-${recipe.id}`}
              >
                <div className="w-12 h-12 bg-worldplate-subtle rounded-lg overflow-hidden flex-shrink-0">
                  {recipe.image_url ? (
                    <img src={recipe.image_url} alt={recipe.name} className="w-full h-full object-cover" />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center">
                      <UtensilsCrossed className="w-6 h-6 text-worldplate-muted" />
                    </div>
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-worldplate-deep truncate">{recipe.name}</p>
                  <p className="text-sm text-worldplate-muted">
                    {recipe.country} • {recipe.prep_time + recipe.cook_time} min
                  </p>
                </div>
              </button>
            ))
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default RecipePickerDialog;
